import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthenticationSelectors } from '../authentication';
import { REQUEST_TENANTS } from './request-tenants';

export const tenantInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const store = inject(Store);

  const plant = store.selectSnapshot(AuthenticationSelectors.activePlant);
  const plants = store.selectSnapshot(AuthenticationSelectors.plants);

  let modified = req;

  if (!plant || req.url.includes('auth.prod.orion.cz.foxconn.com')) {
    return next(req);
  }

  // Single plant
  if (plant !== 'MULTI') {
    modified = req.clone({
      headers: req.headers.set('Request-Tenants', plant),
    });
    return next(modified);
  }

  const selected = req.context.get(REQUEST_TENANTS);
  const tenants = [...new Set(selected.map((code): string => code.trim()).filter(Boolean))];
  if (tenants.length) {
    modified = req.clone({
      headers: req.headers.set('Request-Tenants', tenants.join(',')),
    });
    return next(modified);
  }

  // Unscoped requests and empty filters use all available plants, including MULTI.
  if (Array.isArray(plants) && plants.length > 0) {
    const codes = plants
      .filter((p): boolean => p.Show !== false)
      .map((p): string => p.Code)
      .filter((code): boolean => !!code)
      .join(',');

    modified = req.clone({
      headers: req.headers.set('Request-Tenants', codes),
    });
  }

  return next(modified);
};
